// src/hooks/prompts/useGetInitialFeedbackPrompt.ts

import { AxiosError } from 'axios';
import { useState } from 'react';

import {
  ErrorHttpResponse,
  SuccessHttpResponse,
  HttpConfig,
} from '../../models/https';
import useHttps from '../useHttps';
import { setShowInitialPrompt } from '../../redux/slices/preferencesSlice';
import { useAppDisPatch, useAppSelector } from '../../redux/store';

const useGetInitialFeedbackPrompt = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((s) => s.auth);
  const [loading, setLoading] = useState(false);

  const onSuccess = ({ data }: SuccessHttpResponse<boolean>) => {
    dispatch(setShowInitialPrompt(data));
  };

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.response?.data?.message ??
        'Failed to fetch initial feedback-prompt preference'
    );
  };

  const getInitialFeedbackPrompt = () => {
    if (!authData?.id) {
      console.warn('No user ID – skipping initial prompt fetch');
      return;
    }

    const config: HttpConfig = {
      url: `auth-service/feedback/${authData.id}/can-prompt/initial`,
      method: 'get',
    };

    request(config, onSuccess, setLoading, onError);
  };

  return { getInitialFeedbackPrompt, loading };
};

export default useGetInitialFeedbackPrompt;
